import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row, Space, Tooltip } from 'antd'
import { CheckCircleTwoTone, QuestionCircleTwoTone } from '@ant-design/icons'
import { RolesEnum } from '../../config/rolesEnum'
import { useAppSelector } from '../../hooks/appHook'
import { useGetAccountQuery } from '../../store/api/account.api'
import { useLazyResendCodeQuery } from '../../store/api/auth.api'
import { useSuccessMessage } from '../../hooks/useSuccessMessage'
import { useTranslation } from 'react-i18next'
import './profile.less'
import AiHelperHeader from '../../components/AIHelperHeader/aiHelperHeader'
import { useIntegrationSuccess } from '../../hooks/useIntegrationSuccess'
import AvailableConnectedServices from './components/AvailableConnectedServices'

const Profile = () => {
  const { t } = useTranslation('profile')
  const { user } = useAppSelector((state) => state.appState)
  const { account } = useAppSelector((state) => state.account)
  useIntegrationSuccess()

  useGetAccountQuery(undefined, { refetchOnMountOrArgChange: true })
  const [resendCode, { status }] = useLazyResendCodeQuery()

  useSuccessMessage(t('messages.verificationEmailSent'), status === 'fulfilled')

  const handleVerifyButtonClick = () => {
    resendCode({ email: user.email })
  }

  return (
    <>
      <AiHelperHeader title={t('title')} paragraph="" />
      <div className="profile-wrapper">
        <div>
          <h2>{t('accountProfile')}</h2>
          <Row className="row">
            <Col span={24} sm={12}>
              {t('accountName')}:
            </Col>
            <Col span={24} sm={12}>
              {account.name ? account.name : '-'}
            </Col>
          </Row>
          {user.role === RolesEnum.ADMIN && (
            <>
              <Row className="row">
                <Col span={24} sm={12}>
                  {t('accountStatus')}:
                </Col>
                <Col span={24} sm={12}>
                  {account.status ? account.status : '-'}
                </Col>
              </Row>
            </>
          )}
        </div>

        <div>
          <h2>{t('myProfile')}</h2>
          <Row className="row">
            <Col span={24} sm={12}>
              {t('yourName')}:
            </Col>
            <Col span={24} sm={12}>
              {user.name}
            </Col>
          </Row>
          <Row className="row">
            <Col span={24} sm={12}>
              {t('email')}:
            </Col>
            <Col span={24} sm={12}>
              <Space>
                {user.email}
                <Tooltip placement="bottom" title={t('yourEmailStatus', { status: user.status })}>
                  {user.status === 'verified' ? (
                    <CheckCircleTwoTone twoToneColor="#52c41a" />
                  ) : (
                    <QuestionCircleTwoTone twoToneColor="#FF7625FF" />
                  )}
                </Tooltip>
                {user.status !== 'verified' && (
                  <Button loading={status === 'pending'} onClick={handleVerifyButtonClick}>
                    {t('resendVerificationEmail')}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>
          <Row className="row">
            <Col span={12}></Col>
            <Col span={12}>
              <Link className="edit-btn" to="edit">
                {t('edit')}
              </Link>
            </Col>
          </Row>
        </div>
      </div>
      <AvailableConnectedServices account={account} user={user} />
    </>
  )
}

export default Profile
